<headerCustom></headerCustom>

<!--Functional Skill Rating Form Modal Box-->
<div
  *ngIf="showHideModel"
  class="modal fade adduserPopContainer"
  id="funSkillRatingPopContainer"
  tabindex="-1"
  role="dialog"
  aria-labelledby="funSkillRatingPopContainer"
  aria-hidden="true"
  data-keyboard="false"
  data-backdrop="static"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <form [formGroup]="functionalSkillRatingForm">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">TR Nominee Functional Competency Rating</h5>
          <button
            type="button"
            #closeModel1
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <mat-tab-group [(selectedIndex)]="active">
            <mat-tab label="Current">
              <ng-template matTabContent>
                <div class="notice" *ngIf="!isenabledMFun">
                  You will not be able to fill the ratings yet. You can fill the
                  ratings after this nominee has completed self-rating.
                </div>
                <div class="notice" *ngIf="!isShowCompForm">
                  You will be able to fill the ratings after
                  {{ ratingInDays - diffInDays }} Days
                </div>
                <ng-container *ngIf="isShowCompForm">
                  <div class="row" *ngIf="isenabledMFun">
                    <div class="col-sm-4"></div>
                    <div class="col-sm-8">
                      <div class="row">
                        <div class="col-sm-6">
                          <label>Competency</label>
                        </div>
                        <div class="col-sm-2">
                          <label>Target</label>
                        </div>
                        <div class="col-sm-4">
                          <label>Actual</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row" *ngIf="isenabledMFun">
                    <label
                      for="level"
                      class="col-sm-4 col-form-label control-label"
                      >Competency Levels</label
                    >
                    <div class="col-sm-8">
                      <div class="row">
                        <ng-container
                          *ngFor="let skill of skillData; let i = index"
                        >
                          <ng-container
                            *ngIf="skill.positionId == selectedPositionId"
                          >
                            <div class="col-sm-6" style="margin-bottom: 2px">
                              <label class="form-control"
                                >{{ skill.skillName }}
                                {{
                                  countFunCompLevel(CometencyLevelCount)
                                }}</label
                              >
                            </div>
                            <div class="col-sm-2" style="margin-bottom: 2px">
                              <label class="form-control">{{
                                skill.targetScore
                              }}</label>
                            </div>
                            <div class="col-sm-4">
                              <select
                                class="form-control form-control-lg"
                                placeholder="Select Competency Rating"
                                formControlName="{{ skill.skillName }}"
                                style="width: 135px"
                              >
                                <!-- <option value="">Select Rating</option> -->

                                <ng-container
                                  *ngFor="
                                    let skillRating of skillRatingData;
                                    let i = index
                                  "
                                >
                                  <option
                                    value="{{ skillRating.score }}"
                                    [selected]="skillRating.score == '1'"
                                  >
                                    {{ skillRating.ratingName }}
                                  </option>
                                </ng-container>
                              </select>
                            </div>
                          </ng-container>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                  <ng-container *ngIf="isenabledMFun && CometencyLevelCount">
                    <div class="form-group row" *ngIf="isenabledMFun">
                      <label
                        for="skillRatingFromDate"
                        class="col-sm-4 col-form-label control-label"
                        >Competency Rating Start Date
                      </label>
                      <div class="col-sm-8">
                        <div class="input-group">
                          <input
                            autocomplete="off"
                            [ngClass]="{
                              'is-invalid':
                                submitted && f.skillRatingFromDate.errors
                            }"
                            placeholder="yyyy-mm-dd"
                            ngbDatepicker
                            #d1="ngbDatepicker"
                            [autoClose]="true"
                            formControlName="skillRatingFromDate"
                            class="form-control"
                            required
                          />

                          <div class="input-group-append">
                            <button
                              class="btn hvr-bounce-to-top"
                              (click)="setStartDate(); d1.toggle()"
                              type="button"
                            >
                              <img src="assets/calendar-icon.svg" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group row" *ngIf="isenabledMFun">
                      <label
                        for="skillRatingToDate"
                        class="col-sm-4 col-form-label control-label"
                        >Competency Rating End Date</label
                      >
                      <div class="col-sm-8">
                        <div class="input-group">
                          <input
                            class="form-control"
                            type="text"
                            autocomplete="off"
                            placeholder="yyyy-mm-dd"
                            ngbDatepicker
                            #d2="ngbDatepicker"
                            formControlName="skillRatingToDate"
                          />
                          <div class="input-group-append">
                            <button
                              class="btn hvr-bounce-to-top"
                              (click)="setEndDate(); d2.toggle()"
                              type="button"
                            >
                              <img src="assets/calendar-icon.svg" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row addUserButton mb-2" *ngIf="isenabledMFun">
                      <div class="col-md-12">
                        <button
                          type="button"
                          class="btn hvr-bounce-to-top"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          Cancel
                        </button>
                        <button
                          class="btn hvr-bounce-to-top mr10"
                          (click)="
                            onSubmit(functionalSkillRatingForm.value, true)
                          "
                          [disabled]="
                            functionalSkillRatingForm.invalid ||
                            isenabledMFun == 'false'
                          "
                        >
                          Submit Rating
                        </button>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container
                    *ngIf="isenabledMBeh && CometencyLevelCount < 1"
                  >
                    <div class="notice">Competency Level data not found!.</div>
                  </ng-container>
                </ng-container>
              </ng-template>
            </mat-tab>
            <mat-tab label="History" *ngIf="dateRanges.length > 1">
              <ng-template matTabContent>
                <div class="tableWrapper">
                  <table
                    class="table rTsCustomizeTable ratingsTable"
                    *ngIf="dateRanges.length > 1"
                  >
                    <thead>
                      <tr>
                        <th>S.No.</th>
                        <th>Skill</th>
                        <th *ngFor="let dateRange of dateRanges; index as i">
                          <ng-container *ngIf="dateRange !== 1">
                            {{ dateRange == 1 ? "" : dateRange }}
                          </ng-container>
                        </th>
                      </tr>
                    </thead>
                    <tbody class="text-center">
                      <ng-container
                        *ngFor="let row of convertedData; let i = index"
                      >
                        <tr>
                          <td>
                            <div>{{ i + 1 }}</div>
                          </td>
                          <ng-container *ngFor="let cell of row; let j = index">
                            <td>
                              <div>{{ cell }}</div>
                            </td>
                          </ng-container>
                        </tr>
                      </ng-container>
                    </tbody>
                  </table>
                </div>
              </ng-template>
            </mat-tab>
          </mat-tab-group>
        </div>
        <div class="modal-footer"></div>
      </div>
    </form>
  </div>
</div>

<!--Behavioral Skills Modal Box-->
<div
  *ngIf="showHideModel"
  class="modal fade adduserPopContainer"
  id="behavioralSkillPopContainer"
  tabindex="-1"
  role="dialog"
  aria-labelledby="behavioralSkillPopContainer"
  aria-hidden="true"
  data-keyboard="false"
  data-backdrop="static"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <form [formGroup]="behavioralSkillRatingForm">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">TR Nominee Behavioral Competency Rating</h5>
          <button
            type="button"
            #closeModel2
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body">
          <mat-tab-group [(selectedIndex)]="active">
            <mat-tab label="Current">
              <ng-template matTabContent>
                <div class="notice" *ngIf="!isenabledMBeh">
                  You will not be able to fill the ratings yet. You can fill the
                  ratings after this nominee has completed self-rating.
                </div>
                <div class="notice" *ngIf="!isShowCompForm">
                  You will be able to fill the ratings after
                  {{ ratingInDays - diffInDays }} Days
                </div>
                <ng-container *ngIf="isShowCompForm">
                  <div class="row" *ngIf="isenabledMBeh">
                    <div class="col-sm-4"></div>

                    <div class="col-sm-8">
                      <div class="row">
                        <div class="col-sm-6">
                          <label>Competency</label>
                        </div>
                        <div class="col-sm-2">
                          <label>Target</label>
                        </div>
                        <div class="col-sm-4">
                          <label>Actual</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row" *ngIf="isenabledMBeh">
                    <label
                      for="level"
                      class="col-sm-4 col-form-label control-label"
                      >Competency Levels</label
                    >
                    <div class="col-sm-8">
                      <div class="row">
                        <ng-container
                          *ngFor="let skill of behSkillList; let i = index"
                        >
                          <ng-container
                            *ngIf="skill.positionId === selectedPositionId"
                          >
                            <div class="col-sm-6" style="margin-bottom: 2px">
                              <label class="form-control"
                                >{{ skill.skillName }}
                                {{
                                  countFunCompLevel(CometencyLevelCount)
                                }}</label
                              >
                            </div>
                            <div class="col-sm-2" style="margin-bottom: 2px">
                              <label class="form-control">{{
                                skill.targetScore
                              }}</label>
                            </div>
                            <div class="col-sm-4">
                              <select
                                class="form-control form-control-lg"
                                placeholder="select skill level"
                                formControlName="{{ skill.skillName }}"
                                style="width: 135px"
                              >
                                <!-- <option value="">Select Rating</option> -->

                                <ng-container
                                  *ngFor="
                                    let skillRating of skillRatingData;
                                    let i = index
                                  "
                                >
                                  <option
                                    value="{{ skillRating.score }}"
                                    [selected]="skillRating.score == '1'"
                                  >
                                    {{ skillRating.ratingName }}
                                  </option>
                                </ng-container>
                              </select>
                            </div>
                          </ng-container>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                  <ng-container
                    *ngIf="isenabledMBeh && CometencyLevelCount > 0"
                  >
                    <div
                      class="form-group row"
                      *ngIf="isenabledMBeh && CometencyLevelCount > 0"
                    >
                      <label
                        for="skillRatingFromDate"
                        class="col-sm-4 col-form-label control-label"
                        >Competency Rating Start Date
                      </label>
                      <div class="col-sm-8">
                        <div class="input-group">
                          <input
                            autocomplete="off"
                            [ngClass]="{
                              'is-invalid':
                                submitted && f.skillRatingFromDate.errors
                            }"
                            placeholder="yyyy-mm-dd"
                            ngbDatepicker
                            #d1="ngbDatepicker"
                            formControlName="skillRatingFromDate"
                            class="form-control"
                          />
                          <div class="input-group-append">
                            <button
                              class="btn hvr-bounce-to-top"
                              (click)="setStartDate(); d1.toggle()"
                              type="button"
                            >
                              <img src="assets/calendar-icon.svg" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="form-group row"
                      *ngIf="isenabledMBeh && CometencyLevelCount > 0"
                    >
                      <label
                        for="skillRatingToDate"
                        class="col-sm-4 col-form-label control-label"
                        >Competency Rating End Date</label
                      >
                      <div class="col-sm-8">
                        <div class="input-group">
                          <input
                            class="form-control"
                            type="text"
                            autocomplete="off"
                            placeholder="yyyy-mm-dd"
                            ngbDatepicker
                            #d2="ngbDatepicker"
                            formControlName="skillRatingToDate"
                          />
                          <div class="input-group-append">
                            <button
                              class="btn hvr-bounce-to-top"
                              (click)="setEndDate(); d2.toggle()"
                              type="button"
                            >
                              <img src="assets/calendar-icon.svg" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row addUserButton mb-2" *ngIf="isenabledMBeh">
                      <div class="col-md-12">
                        <button
                          type="button"
                          class="btn hvr-bounce-to-top"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          Cancel
                        </button>

                        <button
                          class="btn hvr-bounce-to-top mr10"
                          (click)="
                            onSubmit(behavioralSkillRatingForm.value, false)
                          "
                          [disabled]="
                            behavioralSkillRatingForm.invalid ||
                            isenabledMBeh == 'false'
                          "
                        >
                          Submit Rating
                        </button>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container
                    *ngIf="isenabledMBeh && CometencyLevelCount < 1"
                  >
                    <div class="notice">Competency Levels data not found!.</div>
                  </ng-container>
                </ng-container>
              </ng-template>
            </mat-tab>
            <mat-tab label="History" *ngIf="dateRanges.length > 1">
              <ng-template matTabContent>
                <div class="tableWrapper">
                  <table
                    class="table rTsCustomizeTable ratingsTable"
                    *ngIf="dateRanges.length > 1"
                  >
                    <thead>
                      <tr>
                        <th>S.No.</th>
                        <th>Skill</th>

                        <th *ngFor="let dateRange of dateRanges; index as i">
                          <ng-container *ngIf="dateRange !== 1">
                            {{ dateRange == 1 ? "" : dateRange }}
                          </ng-container>
                        </th>
                      </tr>
                    </thead>
                    <tbody class="text-center">
                      <ng-container
                        *ngFor="let row of convertedData; let i = index"
                      >
                        <tr>
                          <td>
                            <div>{{ i + 1 }}</div>
                          </td>
                          <ng-container *ngFor="let cell of row; let j = index">
                            <td>
                              <div>{{ cell }}</div>
                            </td>
                          </ng-container>
                        </tr>
                      </ng-container>
                    </tbody>
                  </table>
                </div>
              </ng-template>
            </mat-tab>
          </mat-tab-group>
        </div>
        <div class="modal-footer"></div>
      </div>
    </form>
  </div>
</div>

<!-- Show users details in table -->

<sidebarWrapper></sidebarWrapper>

<div class="main-content">
  <div class="adduserContainer">
    <div class="pageContentWrapper">
      <div class="pageHeading">
        <div class="row">
          <div class="col-6">
            <div class="headerName">
              <h3>Manager Section</h3>
            </div>
          </div>
          <div class="col-6 addUserButton text-right">
            <div class="row">
              <div class="col-12">
                <a
                  class="btn hvr-bounce-to-top mr10"
                  href="assets/behCompetancy.pdf"
                  target="_blank"
                  >Definition</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="addUserButtonTableData" *ngIf="fetchData.length > 0">
        <div
          class="addSkillRatingFormLayout customizeRtsScrollBar addSkillRatingFormContainer"
        >
          <table datatable class="table rTsCustomizeTable">
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Employee Name</th>
                <th>TR Nominee Manager</th>
                <!-- <th>Type of Resource</th> -->
                <th>Current Role</th>
                <th>Next Role</th>
                <th data-orderable="false">Functional Ratings</th>
                <th data-orderable="false">Behavioral Ratings</th>
              </tr>
            </thead>
            <tbody class="text-center">
              <ng-container
                *ngFor="let fetchuserData of fetchData; let i = index"
              >
                <tr>
                  <td>
                    <div ngClass="{{ fetchuserData.leaveUserCSS }}">
                      {{ fetchData.indexOf(fetchuserData) + 1 }}
                    </div>
                  </td>
                  <td class="addUserName">
                    <div ngClass="{{ fetchuserData.leaveUserCSS }}">
                      {{ fetchuserData.userName }}
                    </div>
                  </td>
                  <td class="userSelectType">
                    <div ngClass="{{ fetchuserData.leaveUserCSS }}">
                      {{ fetchuserData.resourceManager }}
                    </div>
                  </td>

                  <td>
                    <div>{{ fetchuserData.positionName }}</div>
                  </td>
                  <td>
                    <div>{{ getPositionName(fetchuserData.nextPosition) }}</div>
                  </td>

                  <td class="addUserButtons">
                    <div>
                      <button
                        class="btn form-group hvr-bounce-to-top"
                        title="Functional Skills Rating"
                        data-toggle="modal"
                        data-target="#funSkillRatingPopContainer"
                        (click)="onEditSubmit(fetchuserData, true)"
                      >
                        <img
                          src="assets/funRating.png"
                          style="margin-left: 2px"
                        />
                        <!-- <i class="fas fa-user-cog"></i> -->
                      </button>
                    </div>
                  </td>
                  <td class="addUserButtons">
                    <div>
                      <button
                        class="btn form-group hvr-bounce-to-top"
                        title="Behavioral Skills Rating"
                        data-toggle="modal"
                        data-target="#behavioralSkillPopContainer"
                        (click)="onEditSubmit(fetchuserData, false)"
                      >
                        <i class="fa fa-tasks"></i>
                        <!-- <img src="assets/behRating.png" /> -->
                      </button>
                    </div>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="loader" *ngIf="loading">
  <div class="lds-roller">
    <!-- <img src="assets/preloader.gif" />
    <span>Wait...</span> -->
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>
